<template>
  <div class="onboard-consent-page-template">
    <OnBoardingActivity class="onboard-activity" @load="loading" @loaded="loaded" :aid="aid" />
    <div class="input-wrapper" style="justify-content: center;">
      <Button
        :loading="isNegativeLoading"
        :disabled="isLoading || (isPositiveLoading && isNegativeLoading)"
        @click="proceed(false)"
        style="margin-top: 10px;"
        size="large"
        type="text"
      >Disagree</Button>
      <a :target="isIOS() ? '_blank' : '_self'" :href="surveyUrl" class="ivu-btn ivu-btn-primary ivu-btn-large">
        <span>Agree</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OnBoardingActivity from "@/components/OnBoardingActivity";
import VueCookie from 'vue-cookie'
import Utils from "@/utils.js";

export default {
  name: "VCOMContentPage",
  data() {
    return {
      isLoading: false,
      isPositiveLoading: false,
      isNegativeLoading: false
    };
  },
  components: {
    OnBoardingActivity
  },
  computed: {
    ...mapGetters("user", ["userInfo", "brandInfo"]),
    surveyUrl() {
      return Utils.getBrandResourcefieldId(this.brandInfo, 'survey_url')
    },
  },
  props: {
    aid: {
      type: String,
      required: true
    }
  },
  methods: {
    isIOS() {
      return ( VueCookie.get('os_type') === "ios" ) ? true : false;
    },
    loaded() {
      this.isLoading = false;
      this.$emit("onLoaded");
    },
    loading() {
      this.isLoading = true;
      this.$emit("onLoading");
    },
    async proceed(isAgree) {
      this.isPositiveLoading = isAgree;
      this.isNegativeLoading = !isAgree;

      try {
        await this.$store.dispatch("user/saveOnboardingData", {
          data: {
            id: this.userInfo.id,
            meta: {
              accept_agreement: isAgree
            }
          },
          newAvatar: null
        });
        await this.$store.dispatch("user/getUserInfo")
      } catch (error) {
        console.log("Unable to save onboarding response", error);
      } finally {
        this.isPositiveLoading = false;
        this.isNegativeLoading = false;
        this.nextPage();
      }
    },
    nextPage() {
      this.$emit("nextPage");
    }
  }
};
</script>

<style lang="scss" scoped>
.onboard-consent-page-template {
  height: 100%;
}
.onboard-activity {
  min-height: 55vh;
  overflow-y: auto;
}
</style>